import { render, staticRenderFns } from "./DataCuesHeader.vue?vue&type=template&id=9b27c40a&scoped=true"
import script from "./DataCuesHeader.vue?vue&type=script&lang=js"
export * from "./DataCuesHeader.vue?vue&type=script&lang=js"
import style0 from "./DataCuesHeader.scss?vue&type=style&index=0&id=9b27c40a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b27c40a",
  null
  
)

export default component.exports